module.exports = {
  siteTitle: 'EventsMadeLive', // <title>
  manifestName: 'EventsMadeLive',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: 'red',
  manifestThemeColor: 'red',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/images/logo.svg',
  pathPrefix: `/gatsby-starter-highlights/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'EventsMadeLive',
  subHeading: 'Video Platform - Simplified',
  // social
  socialLinks: [
    {
      icon: 'fa-envelope-o',
      name: 'Email',
      url: 'mailto:brandon@eventsmadelive.com',
    },
  ],
};
